<div class="dialog-title-row">
  <h2 mat-dialog-title>{{data.title}}</h2>
  <button
    *ngIf="data.showCloseButton"
    class="dialog-close-btn"
    type="button"
    aria-label="Close"
    mat-dialog-close
  >
    &times;
  </button>
</div>
<mat-dialog-content>
  <p>{{data.desc}}</p>
  <ul *ngIf="data.productIds?.length">
    <strong><li *ngFor="let id of data.productIds">{{ id }}</li></strong>
  </ul>
  <p *ngIf="data.showContinueText !== false">Do you want to continue?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngIf="!data.hideNoButton" class="btn" [mat-dialog-close]="false">
    {{ data.noLabel || 'No' }}
  </button>
  <button *ngIf="!data.hideYesButton" class="btn" [mat-dialog-close]="true">
    {{ data.yesLabel || 'Yes' }}
  </button>
</mat-dialog-actions>
